import React from 'react'
import { connect } from 'react-redux'

import * as actions from '../actions'

import * as Content from '../reducers/Content'
import { ReactComponent as ReceivedIcon } from '../assets/groups_black_24dp.svg'

function isFolder(node) {
  return node.content !== undefined
}

const ExpandButton = (props) => (
  <div
    className={`folderTreeExpandButton${props.canExpand ? '' : ' disabled'}`}
    onClick={props.onClick}
  >
    <img
      className="folderTreeExpandButtonIcon"
      src={props.expanded ? '/arrow_down.svg' : '/arrow_forward.svg'}
      alt=""
      draggable="false"
    />
  </div>
)

class Title extends React.Component {
  onClick = () => {
    this.props.onClick(this.props.node.id)
  }

  onClickExpand = (event) => {
    event.stopPropagation()
    this.props.onClickExpand(this.props.node.id)
  }

  render() {
    const {
      node,
      level,
      canExpand,
      expanded,
      selected,
      isReceived,
    } = this.props
    const icon = Content.displayIcon(node, level === 0)
    const title = Content.displayTitle(node, level === 0)
    const style = { paddingLeft: `${Math.max(1, level) * 16}px` }

    return (
      <div
        style={style}
        className={`folderTreeTitle${
          selected ? ' selected' : ''
        } level${level}`}
        onClick={this.onClick}
      >
        <ExpandButton
          canExpand={canExpand}
          expanded={expanded}
          onClick={this.onClickExpand}
        />
        <div className="folderTreeTitleContainer">
          <div className="folderTreeTitleIcon">{icon}</div>
          <div className="folderTreeTitleText">
            {title}
            {isReceived && <ReceivedIcon style={{ float: 'right' }} />}
          </div>
        </div>
      </div>
    )
  }
}

class Folder extends React.Component {
  render() {
    const {
      node,
      selectedId,
      ui,
      level,
      onClickFolder,
      onClickExpandFolder,
      isReceived,
    } = this.props
    const subfolders = node.content.filter((node) => isFolder(node))
    const nodeUI = ui[node.id] ?? {}
    const canExpand = subfolders.length > 0
    return (
      <div className={`folderTreeFolder level${level}`}>
        <Title
          node={node}
          canExpand={canExpand}
          expanded={nodeUI.expanded}
          level={level}
          isReceived={isReceived}
          selected={selectedId === node.id}
          onClick={onClickFolder}
          onClickExpand={onClickExpandFolder}
        />
        {nodeUI.expanded && (
          <div>
            {subfolders.map((node) => (
              <Folder
                key={node.id}
                node={node}
                selectedId={selectedId}
                ui={ui}
                level={level + 1}
                onClickFolder={onClickFolder}
                onClickExpandFolder={onClickExpandFolder}
              />
            ))}
          </div>
        )}
      </div>
    )
  }
}

class FolderTree extends React.Component {
  onClickFolder = (folderId) => {
    this.props.selectNodeId(folderId, this.props.contentId)
  }

  onClickExpandFolder = (folderId) => {
    this.props.toggleExpanded(folderId, this.props.contentId)
  }

  render() {
    const { content, selectedId, ui, isReceived } = this.props
    return (
      <div className="folderTree">
        {content && (
          <Folder
            node={content}
            selectedId={selectedId}
            ui={ui}
            level={0}
            isReceived={isReceived}
            onClickFolder={this.onClickFolder}
            onClickExpandFolder={this.onClickExpandFolder}
          />
        )}
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  const { contentId } = ownProps
  const { receivedContentCollection } = state
  const ui = state.contentUICollection[contentId] ?? {}
  const isReceived = receivedContentCollection.hasOwnProperty(contentId)
  const selectedNodeId =
    contentId === state.app.selectedContentId ? state.app.selectedNodeId : -1
  return {
    selectedId: selectedNodeId,
    ui,
    isReceived,
  }
}

const ConnectedFolderTree = connect(mapStateToProps, actions)(FolderTree)
export default ConnectedFolderTree
